import { useQuery } from '@tanstack/react-query'

import queries from '@/api/queries'
import userResources from '@/api/user'

export const useProfile = (enabled = true) => {
  const { data: profile, isLoading: isProfileLoading } = useQuery(
    queries.profile(),
    userResources.profile,
    {
      staleTime: Infinity,
      enabled,
    }
  )

  return { profile, isProfileLoading }
}
